import { Helmet } from 'react-helmet-async';
import HumanInTheLoopReview from 'app/pages/HumanInTheLoopPage/components/HumanInTheLoopReview';

export default function HumanInTheLoopPage() {
  return (
    <>
      <Helmet>
        <title>Human in the loop review</title>
        <meta
          name="description"
          content="Human in the loop review — templates and segments"
        />
      </Helmet>
      <HumanInTheLoopReview />
    </>
  );
}
